import {useEffect} from "react"
import { useHistory } from "react-router"

const routeStack = [];

const useRoutePath = () => {
    const {location} = useHistory() || {};
    
    useEffect(() => {
        const {pathname} = location
        if(routeStack.length > 5)
        routeStack.splice(3)
        routeStack.push(pathname)
      
    }, [location])
}
export const getRouteStackLength = () =>{
    return routeStack.length;
}

export default useRoutePath;